module.exports = __webpack_public_path__ + "img/avant2.b97e979d.png";